import React, { useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Button, Row, Col, Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { requestLogin } from 'api/login';
import FindPassword from 'components/authentication/FindPassword';
import { onInputChange } from 'function/event';
import { getText } from 'function/language';
import { getHomeURL } from 'function/login';
import { getErrorMessage } from 'function/message';
import useCheckPlantState from 'global/checkPlantState';
import { useConfirmModalState } from 'global/confirmModalState';
import useLoginState from 'global/loginState';
import useObjReducer from 'hooks/useObjReducer';
import { RESPONSE_CODE } from 'types/const';

/**
 * 로그인
 */
const Login = ({ hasLabel }) => {
  /* router */
  const history = useHistory();
  const { search } = useLocation();

  /* recoil */
  const { setCheckPlant } = useCheckPlantState();
  const { setConfirmModal } = useConfirmModalState();
  const { setLogin } = useLoginState();

  /* state */
  // 로그인 비활성화 여부
  const [isDisableLogin, setIsDisableLogin] = useState(false);
  // 비밀번호 찾기 모달 표시 여부
  const [isShowFindPassword, setIsShowFindPassword] = useState(false);
  // 유효성 여부
  const [isInvalid, setIsInvalid] = useState(false);
  // 로그인 요청 데이터
  const [loginData, setLoginData] = useObjReducer({
    userId: '',
    userPwd: ''
  });

  /* event */
  // 로그인
  const onSubmit = async event => {
    event.preventDefault();

    if (!event.currentTarget.checkValidity()) {
      setIsInvalid(true);

      return;
    }

    setIsDisableLogin(true);

    try {
      const { data, code } = await requestLogin(loginData);

      if (code !== RESPONSE_CODE.Success) {
        throw new Error();
      }

      const redirect = new URLSearchParams(search).get('redirect');

      setLogin(data);
      setCheckPlant([data.fatoryCodeSeq]);

      const { haccpYn = 'N' } = data || {};

      // 배합비
      if (redirect && haccpYn === 'N') {
        location.assign(redirect);
        return;
      }

      // 로그인 사용자가 해당되는 홈 화면 표시
      history.push(getHomeURL());
    } catch {
      setConfirmModal({
        isOpen: true,
        title: 'errorLogin',
        message: getErrorMessage(RESPONSE_CODE.ErrorLogin)
      });
      setIsDisableLogin(false);
    }
  };

  /* view */
  return (
    <>
      <Form validated={isInvalid} noValidate onSubmit={onSubmit}>
        <Form.Group className="mb-3">
          {hasLabel && <Form.Label>{getText('userId')}</Form.Label>}
          <Form.Control
            type="text"
            value={loginData.userId}
            autoFocus
            name="userId"
            placeholder={!hasLabel && getText('userId')}
            required
            onChange={event => onInputChange(event, setLoginData)}
          />
        </Form.Group>
        <Form.Group className="mb-3">
          {hasLabel && <Form.Label>{getText('userPwd')}</Form.Label>}
          <Form.Control
            type="password"
            value={loginData.userPwd}
            name="userPwd"
            placeholder={!hasLabel && getText('userPwd')}
            required
            onChange={event => onInputChange(event, setLoginData)}
          />
        </Form.Group>
        <Form.Group>
          <Button
            disabled={isDisableLogin}
            type="submit"
            className="w-100"
            color="primary"
          >
            {getText('login')}
          </Button>
        </Form.Group>
        <Row className="align-items-center justify-content-end">
          <Col xs="auto">
            <Link
              to="#!"
              className="fs--1 mb-0 text-primary"
              onClick={() => setIsShowFindPassword(true)}
            >
              {getText('findUserPwd')}
            </Link>
          </Col>
        </Row>
      </Form>
      <FindPassword
        show={isShowFindPassword}
        onHide={() => setIsShowFindPassword(false)}
      />
    </>
  );
};

Login.propTypes = {
  layout: PropTypes.string,
  hasLabel: PropTypes.bool
};
Login.defaultProps = {
  layout: 'simple',
  hasLabel: false
};

export default Login;
